import type { LibraryBlock } from "../build";
import { CALLS } from "./calls";
import { CARDS } from "./cards";
import { CHARTS } from "./charts";
import { COLLAGES } from "./collages";
import { EFFECT_TITLES } from "./effects";
import { FRAMES } from "./frames";
import { INFOGRAPHICS } from "./infographics";
import { INTROS } from "./intro";
import { LOWER_THIRDS } from "./lower-thirds";
import { MOCKUPS } from "./mockups";
import { NOTICES } from "./notices";
import { NUMBERS } from "./numbers";
import { PHOTO_FRAMES } from "./photo-frames";
import { QUOTES } from "./quotes";
import { SOCIAL } from "./social";
import { STICKERS } from "./stickers";
import { TITLES } from "./titles";

/**
 * The built-in building blocks (docs/04-dokumentformat.md "Bausteine"), one
 * file per category. Coordinates are relative to the block on the reference
 * scale (shorter page side = 1080 px); colours and text styles are brand
 * roles. Node times are relative to the block's start and end with it.
 */
export const LIBRARY_BLOCKS: readonly LibraryBlock[] = [
  ...LOWER_THIRDS,
  ...TITLES,
  ...EFFECT_TITLES,
  ...INTROS,
  ...SOCIAL,
  ...CARDS,
  ...NUMBERS,
  ...CHARTS,
  ...INFOGRAPHICS,
  ...QUOTES,
  ...CALLS,
  ...NOTICES,
  ...STICKERS,
  ...FRAMES,
  ...PHOTO_FRAMES,
  ...COLLAGES,
  ...MOCKUPS,
];

export function getLibraryBlock(id: string): LibraryBlock | undefined {
  return LIBRARY_BLOCKS.find((block) => block.id === id);
}
